import { render, staticRenderFns } from "./UserProfilePasswordDialog.vue?vue&type=template&id=60cef4a0&"
import script from "./UserProfilePasswordDialog.vue?vue&type=script&lang=ts&"
export * from "./UserProfilePasswordDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports